import { createSlice } from '@reduxjs/toolkit';

import { Sports } from 'enums/sport';
import Language from 'enums/language';

import { ConfigSliceState } from './configSliceState';
import { RootState } from 'rootReducer';

const initialState: ConfigSliceState = {
  lang: Language.NORWEGIAN,
  notAuthenticated: false,
  notAuthenticatedCode: null,
  sport: Sports.FOOTBALL,
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    changeLang(state, action) {
      state.lang = action.payload;
    },
    setNotAuthenticated(state, action) {
      state.notAuthenticated = true;
      state.notAuthenticatedCode = action.payload;
    },
  },
});

export const { changeLang, setNotAuthenticated } = configSlice.actions;

export const selectLang = (state: RootState): string => state.config.lang;

export const selectNotAuthenticated = (state: RootState): boolean => state.config.notAuthenticated;
export const selectNotAuthenticatedCode = (state: RootState): number | null => state.config.notAuthenticatedCode;

export default configSlice.reducer;
